export const isAuthenticationRedirectUrl = (url: string): boolean => {
	return (
		(url.includes('vihreaenergia') || url.includes('alyenergia')) &&
		!url.includes('tunnistus.telia')
	)
}

export const getAuthParamsFromUrl = (urlString: string) => {
	const url = new URL(urlString)
	const params = new URLSearchParams(url.search)

	return {
		code: params.get('code'),
		error: params.get('error'),
	}
}
